import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../config/api";
import Swal from "sweetalert2";

const AddTask = () => {
  const [staffId, setStaffId] = useState(""); // Start empty
  const [staffList, setStaffList] = useState([]); // Staff from API
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [time, setTime] = useState("");
  const [status, setStatus] = useState("Pending");
  const [type, setType] = useState("Variable");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Fetch staff list on mount
  useEffect(() => {
    fetch(`${BASE_URL}staff`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 1) {
          setStaffList(data.data);
        }
      })
      .catch((err) => console.error("Error fetching staff list:", err));
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);

    const taskData = {
      staff_id: parseInt(staffId),
      title,
      description,
      time,
      status,
      type,
    };

    fetch(`${BASE_URL}tasks`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(taskData),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === 1) {
          Swal.fire({
            icon: "success",
            title: "Task Created",
            text: "The task has been successfully added.",
            confirmButtonColor: "#3085d6",
          }).then(() => navigate("/TaskList"));
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: data.message || "Failed to create task.",
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error("Error creating task:", err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong. Please try again.",
        });
      });
  };

  return (
    <div id="main">
      <header className="mb-3">
        <a href="#" className="burger-btn d-block d-xl-none">
          <i className="bi bi-justify fs-3"></i>
        </a>
      </header>

      <div className="page-heading">
        <div className="page-title">
          <div className="row">
            <div className="col-12 col-md-6 order-md-1 order-last">
              <h3>Add Task</h3>
            </div>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-12 col-md-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Create a New Task</h4>
              </div>
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  {/* Staff Dropdown */}
                  <div className="mb-3">
                    <label htmlFor="staffId" className="form-label">
                      Select Staff
                    </label>
                    <select
                      id="staffId"
                      className="form-control"
                      value={staffId}
                      onChange={(e) => setStaffId(e.target.value)}
                      required
                    >
                      <option value="">Select Staff</option>
                      {staffList.map((staff) => (
                        <option key={staff.id} value={staff.id}>
                          {staff.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="title" className="form-label">
                      Title
                    </label>
                    <input
                      type="text"
                      id="title"
                      className="form-control"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="description" className="form-label">
                      Description
                    </label>
                    <textarea
                      id="description"
                      className="form-control"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="time" className="form-label">
                      Time
                    </label>
                    <input
                      type="datetime-local"
                      id="time"
                      className="form-control"
                      value={time}
                      onChange={(e) => setTime(e.target.value)}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="status" className="form-label">
                      Status
                    </label>
                    <select
                      id="status"
                      className="form-control"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                      required
                    >
                      <option value="Pending">Pending</option>
                      <option value="In Progress">In Progress</option>
                      <option value="Completed">Completed</option>
                    </select>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Creating..." : "Create Task"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AddTask;
